import { render, staticRenderFns } from "./editKioskConfig.vue?vue&type=template&id=0bcb3db4"
import script from "./editKioskConfig.vue?vue&type=script&lang=js"
export * from "./editKioskConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports